<section class="error-404__section">
  <div class="error-404__container">
    <div class="error-404__text">
      <div class="error-404__text__title" [innerHTML]="title"></div>
      <div
        class="error-404__text__description"
        [innerHTML]="description | unescape"
      ></div>
    </div>
    <div class="error-404__button-wrapper">
      @if (statusCode == 404) {
        <a class="error-404__button" [routerLink]="['/']">
          {{ "texts.Error404Section_go_to_homepage" | translate }}
        </a>
      } @else {
        @if (statusCode == 403) {
          <a class="error-404__button" [routerLink]="['/']">
            {{ "texts.Error403Section_go_to_homepage" | translate }}
          </a>
        } @else {
          @if (statusCode == 401 && !googleError) {
            <button
              type="button"
              class="error-404__button"
              (click)="openLogin()"
            >
              {{ "texts.Error401Section_log_in" | translate }}
            </button>
          }

          @if (statusCode == 401 && googleError) {
            <a class="error-404__button" [routerLink]="['/']">
              {{ "texts.Error403Section_go_to_homepage" | translate }}
            </a>
          }
        }
      }

      @if (statusCode == 500) {
        <button
          type="button"
          class="error-404__button"
          (click)="reload()"
          style="margin-top: 15px"
        >
          {{ "texts.Error500Section_try_again" | translate }}
        </button>
        <hr style="max-width: 400px; margin: 1rem auto" />
        <a class="error-404__button" [routerLink]="['/']">
          {{ "texts.Error500Section_go_to_homepage" | translate }}
        </a>
      }
    </div>
  </div>
</section>
